//Date Pipe to use FEATURE_TIME_FORMAT_TIME_STAMP config by default
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ConfigService } from '../services/config/config.service';

@Pipe({
    name: 'dateTimestampFormat',
    standalone: true
})
export class DateTimestampFormatPipe  implements PipeTransform {
    constructor (private config: ConfigService, private datePipe: DatePipe ) {}

    transform(value: Date | string | number, format?: string, timezone?: string, locale?: string): string | null {
        let formatTo = this.config.getConfig().FEATURE_TIME_FORMAT_TIME_STAMP;
        if (!formatTo) {
            formatTo = format ? format : 'MM/dd/yyyy, hh:mm a';
        }
        return this.datePipe.transform(value, formatTo, timezone, locale);
    }
}